import { useSyncExternalStore } from 'react'

type TTokenListener = () => void

let accessToken: string | null = null
const listeners = new Set<TTokenListener>()

function emitChange(): void {
  listeners.forEach((listener) => listener())
}

export function getToken(): string | null {
  return accessToken
}

export function setToken(token: string): void {
  accessToken = token
  emitChange()
}

export function clearToken(): void {
  accessToken = null
  emitChange()
}

function subscribe(listener: TTokenListener): () => void {
  listeners.add(listener)
  return (): void => {
    listeners.delete(listener)
  }
}

function getSnapshot(): string | null {
  return getToken()
}

/**
 * React hook that reactively tracks the in-memory access token.
 * Uses useSyncExternalStore for tear-free reads (React 19 compatible).
 */
export function useToken(): string | null {
  return useSyncExternalStore(subscribe, getSnapshot)
}
